import { render } from "./wokerDetail20.vue?vue&type=template&id=fe53b810&scoped=true"
import script from "./wokerDetail20.vue?vue&type=script&lang=js"
export * from "./wokerDetail20.vue?vue&type=script&lang=js"

import "./wokerDetail20.vue?vue&type=style&index=0&id=fe53b810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe53b810"]])

export default __exports__